import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Flex, Image } from "theme-ui";

import tBackIcon from "assets/img/ico_back.png";

interface HeaderBarProps {
  hasBackButton: boolean;
  title: string;
  onGoBack?: () => void;
}

const defaultProps = {
  hasBackButton: false,
  hasMenuButton: true,
  title: "공뿌마켓 POS",
};

function HeaderBar({ hasBackButton, title, onGoBack }: HeaderBarProps) {
  const history = useHistory();

  function handleBackButtonClick() {
    if (hasBackButton) {
      if (onGoBack) {
        onGoBack();
      } else {
        history.goBack();
      }
    }
  }

  return (
    <>
      <Flex
        bg='primaryLight'
        color='headerFontColor'
        sx={{
          alignItems: "center",
          fontSize: "20px",
          fontWeight: "700",
          height: "50px",
          padding: "12px",
          position: "relative",
          textAlign: "center",
        }}
      >
        <Flex
          sx={{
            alignItems: "center",
            cursor: hasBackButton ? "pointer" : "unset",
            display: "inline-flex",
            flex: "1",
            height: "100%",
            justifyContent: "flex-start",
            zIndex: 100,
          }}
          onClick={handleBackButtonClick}
        >
          {hasBackButton && (
            <Box sx={{ height: "100%" }}>
              <Image height='24px' src={tBackIcon} width='24px' />
            </Box>
          )}
        </Flex>
        <Flex
          sx={{
            alignItems: "center",
            display: "inline-flex",
            flex: "1",
            height: "50px",
            justifyContent: "center",
            position: "fixed",
            width: "100%",
            zIndex: 50,
          }}
        >
          <Box>{title}</Box>
        </Flex>
      </Flex>
    </>
  );
}

HeaderBar.defaultProps = defaultProps;

export default HeaderBar;
